import { useSelector } from "react-redux";

import { ReduxApplicationState } from "../types/ReduxTypes/ReduxApplicationState";

export const useIsAdminUser = (): boolean => {
  return useSelector((state: ReduxApplicationState) => state.user.isAdmin);
};
